import { render, staticRenderFns } from "./ticketInfo.vue?vue&type=template&id=c9bca558&scoped=true&"
import script from "./ticketInfo.vue?vue&type=script&lang=js&"
export * from "./ticketInfo.vue?vue&type=script&lang=js&"
import style0 from "./ticketInfo.vue?vue&type=style&index=0&id=c9bca558&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bca558",
  null
  
)

export default component.exports